import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  height: 100%;
  min-height: 0;

  .p-inputtextarea {
    width: 100%;
    height: 42px;
    min-height: 42px;
    max-height: 100px;
    resize: none;
    overflow-y: auto;
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 10px 12px;
    color: #6e6b7b;
    box-shadow: none;
    transition: height 0.2s ease, min-height 0.2s ease;

    &::-webkit-scrollbar {
      width: 8px;
      background-color: transparent;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 4px;
    }
  }

  .p-inputtextarea:enabled:focus {
    box-shadow: none;
    border: 1px solid #ced4da;
  }

  .createTextarea.expanded.p-inputtextarea {
    height: 150px;
    min-height: 150px;
  }

  .createTextarea.expanded.p-inputtextarea:enabled:focus {
    height: 150px;
    min-height: 150px;
  }

  .editTextarea.p-inputtextarea {
    height: 150px;
    min-height: 150px;
  }

  .editTextarea.p-inputtextarea:enabled:focus {
    height: 150px;
    min-height: 150px;
  }

  .p-inputtextarea::placeholder {
    color: #b2b7bf;
  }

  button {
    width: fit-content;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    color: #14223b;
    padding: 8px 14px;
    cursor: pointer;
    font-weight: 600;
  }

  .create {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .bottomCreate {
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  .notesList {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding-right: 6px;

    &::-webkit-scrollbar {
      width: 8px;
      background-color: transparent;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c1c1;
      border-radius: 4px;
    }
  }

  .noteItem {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 10px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fff;
  }

  .edit {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .noteHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    cursor: pointer;
    transition: opacity 0.2s ease;
  }

  .noteHeader:hover {
    opacity: 0.9;
  }

  .noteText {
    position: relative;
    color: #14223b;
    font-size: 13px;
    white-space: pre-wrap;
    word-break: break-word;
    flex: 1;
    max-height: 58px;
    overflow: hidden;
  }

  .noteItem.collapsible:not(.expanded) .noteText::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 24px;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
    pointer-events: none;
  }

  .noteItem.expanded .noteText {
    max-height: none;
  }

  .noteMeta {
    color: #6e6b7b;
    font-size: 11px;
  }

  .noteActions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .actionButton {
    width: 32px;
    height: 32px;
    min-width: 32px;
    padding: 0;
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    cursor: pointer;
  }

  .actionButton:hover {
    background: transparent;
    color: #374151;
    box-shadow: none;
    border: none;
  }

  .actionButton.delete {
    color: #6b7280;
  }

  .footerButton {
    display: flex;
    justify-content: flex-end;
  }
`;

export const ObservationCounter = styled.span`
  margin-top: -4px;
  font-size: 12px;
  color: #6e6b7b;
  margin-left: auto;
`;
